import { useState, useMemo } from 'react';
import { validateGeneralInfo, validateSourceFile } from "../../../utils/formValidations";

export const useConfirmationValidation = (formData: any) => {
  const [showOverrideWarning, setShowOverrideWarning] = useState(false);

  //helpers that verify all required fields are filled
  const isGeneralComplete = useMemo(() => validateGeneralInfo(formData), [formData]);
  const isSourceFileComplete = useMemo(() => validateSourceFile(formData), [formData]);

  const canSave = isGeneralComplete && isSourceFileComplete;

  const incompleteSections = useMemo(() => {
    const sections = [];
    if (!isGeneralComplete) sections.push("General Information");
    if (!isSourceFileComplete) sections.push("Source File");
    return sections;
  }, [isGeneralComplete, isSourceFileComplete]);

  return {
    isGeneralComplete,
    isSourceFileComplete,
    canSave,
    incompleteSections,
    showOverrideWarning,
    setShowOverrideWarning
  };
};